
  import createMeisterIcons from '../src/createMeisterIcons';

  const Square8 = createMeisterIcons("square-8", [["path",{"fill":"currentColor","d":"M3.75 7c0-1.886 1.364-3.25 3.25-3.25h10A3.26 3.26 0 0 1 20.25 7v1.15H3.75zm0 2.65V17A3.26 3.26 0 0 0 7 20.25h.25V9.65zm11.5 10.6h-6.5V9.65h6.5zm1.5 0H17A3.26 3.26 0 0 0 20.25 17V9.65h-3.5zM7 2.25C4.286 2.25 2.25 4.286 2.25 7v10A4.76 4.76 0 0 0 7 21.75h10A4.76 4.76 0 0 0 21.75 17V7A4.76 4.76 0 0 0 17 2.25z","key":"e873e452e416561a739dac42b00f6a44bd56ac42","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Square8
  